// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signupFormContent{font-size:.875rem;text-align:left}.signupFormContent div:not([class*=checkboxDesc]) label{color:#120a20;font-size:1rem;font-weight:700}.signupFormContent p{color:#aaa7b0;font-size:.875rem}._4FFlHoeMZh1qm5-yuq8TT{margin-bottom:1.5rem}._4FFlHoeMZh1qm5-yuq8TT span{margin:0}.zwTM5TB29qaV51Nq2dF5y{display:flex;align-items:center;font-size:1rem;font-weight:bold;margin-bottom:-0.5rem}.zwTM5TB29qaV51Nq2dF5y ._3N3K_TzH6ue0ct_fZSfyli{display:flex;align-items:center;background-color:#a0a0a0;padding:.2rem .75rem;margin-left:.5rem;border-radius:.75rem;font-size:.875rem;color:#fff;font-weight:500;max-height:1.25rem}", ""]);
// Exports
exports.locals = {
	"or": "_4FFlHoeMZh1qm5-yuq8TT",
	"newsletterTitle": "zwTM5TB29qaV51Nq2dF5y",
	"newsletterBadge": "_3N3K_TzH6ue0ct_fZSfyli"
};
module.exports = exports;
